import React from "react";
import SocialLogin from "react-social-login";

// Social media buttons components
// Shows second social media option for login
class SocialButton3 extends React.Component {
  render() {
    const { children, triggerLogin, ...props } = this.props;
    return (
      <>
        <button  onClick={triggerLogin}  {...props}  className={`google ${children === undefined ? 'small' : ''} p-button`} >
            {children}
        </button>
      </>
    );
  }
}

export default SocialLogin(SocialButton3);